import { latitudeValidator, longitudeValidator, numericValidator, uniqueValidator, colorValidator } from 'functions/validation';
import { getEffectiveTableSettings } from 'store/functions/tableSettingsOverrides.js';
import { uniqueValidationHelper } from './utils.js';
import { validateDateTimeColumns } from './validateDateTimeColumns.js';

export const validateRow = (state, tableName, rowIdx, replaceUniques=false) => {
  let isValid = true;
  let validationMessages = [];
  const dataRow = state['data'][tableName][rowIdx];
  // Coordinate-system-aware schema: presentation keys (headers / validation /
  // adornments) differ on a cartesian scenario, which relabels lat/lng to X/Y
  // and validates them as plain numbers rather than geographic ranges.
  const coordinateSystem = state.generalSettings?.mapping?.coordinateSystem ?? 'geographic';
  const tableSchema = getEffectiveTableSettings(tableName, coordinateSystem);
  if (!state['tableSettings'][tableName]) {}
  else if (!tableSchema['columnName']) {throw new Error('Expecting columnName in tableSettings for ' + tableName)}
  else if (!state['tableSettings'][tableName]['isViewable']) {throw new Error('Expecting isViewable in tableSettings for ' + tableName)}
  else if (!tableSchema['isRequired']) {throw new Error('Expecting isRequired in tableSettings for ' + tableName)}
  else if (!tableSchema['validation']) {throw new Error('Expecting validation in tableSettings for ' + tableName)}
  else if (!tableSchema['dataType']) {throw new Error('Expecting dataType in tableSettings for ' + tableName)}
  else if (!tableSchema['columnHeader']) {throw new Error('Expecting columnHeader in tableSettings for ' + tableName)}
  else {
    tableSchema['columnName'].forEach((columnName) => {
      if (columnName === "Valid") {
        // do nothing
      }
      else if (columnName === "validationMessage") {
        // do nothing
      }
      else if (!state['tableSettings'][tableName]['isViewable'][columnName]) {
        // do nothing if column not viewable
      }

      else {
        const element = dataRow[columnName];
        let validation = {valid:true};
        if (tableSchema['isRequired'][columnName] && (element === undefined || element === null)) {
          const header = tableSchema['columnHeader'][columnName] || columnName;
          validation = {valid:false, message:"Required field (" + header + ') not entered'};
        }

        if (element && tableSchema['dropdownSource'] && tableSchema['dropdownSource'][columnName]) {
          const dropdownSource = tableSchema['dropdownSource'][columnName];
          if (dropdownSource) {
              const dropdownTableName = dropdownSource.tableName
              const dataColumn = dropdownSource['column']
              const dropdownFilter = dropdownSource.filter ?? null;
              const filterApplies = dropdownFilter && (
                !dropdownFilter.modelTypes || dropdownFilter.modelTypes.includes(state.activeModelType)
              );
              const sourceRows = state['data'][dropdownTableName];
              const filteredRows = filterApplies
                ? sourceRows.filter(row => row?.[dropdownFilter.field] === dropdownFilter.value)
                : sourceRows;
              const uniqueValues = [...new Set(filteredRows.map(row => row[dataColumn]))];
              // Build unfiltered values only when filter is active, to distinguish "doesn't exist" from "fails filter"
              const allValues = filterApplies
                ? [...new Set(sourceRows.map(row => row[dataColumn]))]
                : null;

              // Use columnHeader labels where available for human-readable messages
              const colHeader = tableSchema['columnHeader']?.[columnName] || columnName;
              const sourceTableSettings = getEffectiveTableSettings(dropdownTableName, coordinateSystem);
              const sourceColHeader = sourceTableSettings?.['columnHeader']?.[dataColumn] || dataColumn;
              const sourceTableTitle = sourceTableSettings?.['title'] || dropdownTableName;
              const filterFieldHeader = sourceTableSettings?.['columnHeader']?.[dropdownFilter?.field] || dropdownFilter?.field;

              const filterViolationMessage = (item) =>
                `"${item}" is not valid for "${colHeader}": ${filterFieldHeader} must equal ${JSON.stringify(dropdownFilter.value)}`;
              const notFoundMessage = (item) =>
                `"${item}" does not appear in the "${sourceColHeader}" column of the ${sourceTableTitle} table.`;

              if (tableSchema['dataType'][columnName] === 'multi-dropdown') {
                element.forEach((item) => {
                  if (item && !uniqueValues.includes(item)) {
                    const failsFilter = dropdownFilter && allValues && allValues.includes(item);
                    validation = {valid: false, message: failsFilter ? filterViolationMessage(item) : notFoundMessage(item)};
                  }
                })
              }
              else if (!uniqueValues.includes(element)) {
                const failsFilter = dropdownFilter && allValues && allValues.includes(element);
                validation = {valid: false, message: failsFilter ? filterViolationMessage(element) : notFoundMessage(element)};
              }
              else {
                validation = {valid: true, message: null};
              }
          }
        }


        else {
          const validationType = tableSchema['validation'][columnName];
          if (validationType === 'latitude') {
            validation = latitudeValidator({newValue:element, columnName:columnName})
          }
          else if (validationType === 'longitude') {
            validation = longitudeValidator({newValue:element, columnName:columnName})
          }
          else if (validationType === 'numeric') {
            validation = numericValidator({newValue:element, columnName:columnName})
          }

          else if (validationType === 'color') {
            validation = colorValidator({newValue:element, columnName:columnName})
          }

          else if (validationType === 'unique') {
            if (!replaceUniques) {
              validation = uniqueValidator({newValue:element, data:state['data'][tableName], row:null, columnName:columnName, entered:true});
            } else {
              const [isValid, adjValue] = uniqueValidationHelper({newValue:element, data:state['data'][tableName], row:null, columnName:columnName, entered:true})
              if (!isValid) {
                state['data'][tableName][rowIdx][columnName] = adjValue;
                validation = uniqueValidator({newValue:element, data:state['data'][tableName], row:null, columnName:columnName, entered:true});
              }
            }
          }
        }

        if (validation.valid) {
          if (validation.valid === 'warning') {
            isValid = 'warning';
            validationMessages.push(validation.message);
          }
        }
        else {
          isValid = false;
          validationMessages.push(validation.message);
        }
      }
    });
  }

  if (tableSchema['timeWindows']) {
    /**
     * If the table has time windows, we need to check to see if the time windows are valid, which means
     * to make sure that the end time is after the start time, if both are active
     */

    const timeValidation = validateDateTimeColumns(state, tableName, dataRow, validationMessages, isValid);
    isValid = timeValidation.valid;
    validationMessages = timeValidation.messages;
   
  }

  state['data'][tableName][rowIdx]['Valid'] = isValid;
  state['data'][tableName][rowIdx]['validationMessage'] = validationMessages;
  return state;  
}

export const validateTable = (state, tableName) => {
  state['data'][tableName].forEach((_, rowIdx) => {
    state['data'][tableName][rowIdx]['Valid'] = true;
    state = validateRow(state, tableName, rowIdx);
  })
  return state
}
